import {
    Activity,
    Airplay,
    AlarmCheck,
    AlarmClock,
    AlarmClockOff,
    AlarmMinus,
    AlarmPlus,
    Album,
    AlertCircle,
    AlertOctagon,
    AlertTriangle,
    AlignCenter,
    AlignCenterHorizontal,
    AlignCenterVertical,
    AlignEndHorizontal,
    AlignEndVertical,
    AlignHorizontalDistributeCenter,
    AlignHorizontalDistributeEnd,
    AlignHorizontalDistributeStart,
    AlignHorizontalJustifyCenter,
    AlignHorizontalJustifyEnd,
    AlignHorizontalJustifyStart,
    AlignHorizontalSpaceAround,
    AlignHorizontalSpaceBetween,
    AlignJustify,
    AlignLeft,
    AlignRight,
    AlignStartHorizontal,
    AlignStartVertical,
    AlignVerticalDistributeCenter,
    AlignVerticalDistributeEnd,
    AlignVerticalDistributeStart,
    AlignVerticalJustifyCenter,
    AlignVerticalJustifyEnd,
    AlignVerticalJustifyStart,
    AlignVerticalSpaceAround,
    AlignVerticalSpaceBetween,
    Anchor,
    Angry,
    Annoyed,
    Aperture,
    AppWindow,
    Apple,
    Archive,
    ArchiveRestore,
    ArchiveX,
    AreaChart,
    Armchair,
    ArrowBigDown,
    ArrowBigDownDash,
    ArrowBigLeft,
    ArrowBigLeftDash,
    ArrowBigRight,
    ArrowBigRightDash,
    ArrowBigUp,
    ArrowBigUpDash,
    ArrowDown,
    ArrowDown01,
    ArrowDown10,
    ArrowDownAZ,
    ArrowDownCircle,
    ArrowDownFromLine,
    ArrowDownLeft,
    ArrowDownLeftFromCircle,
    ArrowDownLeftSquare,
    ArrowDownNarrowWide,
    ArrowDownRight,
    ArrowDownRightFromCircle,
    ArrowDownRightSquare,
    ArrowDownSquare,
    ArrowDownToDot,
    ArrowDownToLine,
    ArrowDownUp,
    ArrowDownWideNarrow,
    ArrowDownZA,
    ArrowLeft,
    ArrowLeftCircle,
    ArrowLeftFromLine,
    ArrowLeftRight,
    ArrowLeftSquare,
    ArrowLeftToLine,
    ArrowRight,
    ArrowRightCircle,
    ArrowRightFromLine,
    ArrowRightLeft,
    ArrowRightSquare,
    ArrowRightToLine,
    ArrowUp,
    ArrowUp01,
    ArrowUp10,
    ArrowUpAZ,
    ArrowUpCircle,
    ArrowUpDown,
    ArrowUpFromDot,
    ArrowUpFromLine,
    ArrowUpLeft,
    ArrowUpLeftFromCircle,
    ArrowUpLeftSquare,
    ArrowUpNarrowWide,
    ArrowUpRight,
    ArrowUpRightFromCircle,
    ArrowUpRightSquare,
    ArrowUpSquare,
    ArrowUpToLine,
    ArrowUpWideNarrow,
    ArrowUpZA,
    Asterisk,
    AtSign,
    Atom,
    Award,
    Axe,
    Axis3D,
    Baby,
    Backpack,
    Badge,
    BadgeAlert,
    BadgeCheck,
    BadgeDollarSign,
    BadgeHelp,
    BadgeInfo,
    BadgeMinus,
    BadgePercent,
    BadgePlus,
    BadgeX,
    BaggageClaim,
    Ban,
    Banana,
    Banknote,
    BarChart,
    BarChart2,
    BarChart3,
    BarChart4,
    BarChartBig,
    BarChartHorizontal,
    BarChartHorizontalBig,
    Baseline,
    Bath,
    Battery,
    BatteryCharging,
    BatteryFull,
    BatteryLow,
    BatteryMedium,
    BatteryWarning,
    Beaker,
    Bean,
    BeanOff,
    BedDouble,
    BedSingle,
    Beef,
    Beer,
    Bell,
    BellDot,
    BellMinus,
    BellOff,
    BellPlus,
    BellRing,
    Bike,
    Binary,
    Biohazard,
    Bird,
    Bitcoin,
    Blinds,
    Blocks,
    Bluetooth,
    BluetoothConnected,
    BluetoothOff,
    BluetoothSearching,
    Bold,
    Bomb,
    Bone,
    Book,
    BookA,
    BookAudio,
    BookCheck,
    BookCopy,
    BookDashed,
    BookDown,
    BookHeadphones,
    BookHeart,
    BookImage,
    BookKey,
    BookLock,
    BookMarked,
    BookMinus,
    BookOpen,
    BookOpenCheck,
    BookOpenText,
    BookPlus,
    BookTemplate,
    BookText,
    BookType,
    BookUp,
    BookUp2,
    BookUser,
    BookX,
    Bookmark,
    BookmarkCheck,
    BookmarkMinus,
    BookmarkPlus,
    BookmarkX,
    Bot,
    Box,
    BoxSelect,
    Boxes,
    Braces,
    Brackets,
    Brain,
    BrainCircuit,
    BrainCog,
    Briefcase,
    BringToFront,
    Brush,
    Bug,
    Building,
    Building2,
    Bus,
    BusFront,
    Cable,
    CableCar,
    Cake,
    CakeSlice,
    Calculator,
    Calendar,
    CalendarCheck,
    CalendarCheck2,
    CalendarClock,
    CalendarDays,
    CalendarHeart,
    CalendarMinus,
    CalendarOff,
    CalendarPlus,
    CalendarRange,
    CalendarSearch,
    CalendarX,
    CalendarX2,
    Camera,
    CameraOff,
    CandlestickChart,
    Candy,
    CandyCane,
    CandyOff,
    Car,
    CarFront,
    CarTaxiFront,
    Carrot,
    CaseLower,
    CaseSensitive,
    CaseUpper,
    Cast,
    Castle,
    Cat,
    Check,
    CheckCheck,
    CheckCircle,
    CheckCircle2,
    CheckSquare,
    ChefHat,
    Cherry,
    ChevronDown,
    ChevronDownSquare,
    ChevronFirst,
    ChevronLast,
    ChevronLeft,
    ChevronLeftSquare,
    ChevronRight,
    ChevronRightSquare,
    ChevronUp,
    ChevronUpSquare,
    ChevronsDown,
    ChevronsDownUp,
    ChevronsLeft,
    ChevronsLeftRight,
    ChevronsRight,
    ChevronsRightLeft,
    ChevronsUp,
    ChevronsUpDown,
    Chrome,
    Church,
    Cigarette,
    CigaretteOff,
    Circle,
    CircleDashed,
    CircleDollarSign,
    CircleDot,
    CircleDotDashed,
    CircleEllipsis,
    CircleEqual,
    CircleOff,
    CircleSlash,
    CircleSlash2,
    CircleUser,
    CircleUserRound,
    CircuitBoard,
    Citrus,
    Clapperboard,
    Clipboard,
    ClipboardCheck,
    ClipboardCopy,
    ClipboardEdit,
    ClipboardList,
    ClipboardPaste,
    ClipboardSignature,
    ClipboardType,
    ClipboardX,
    Clock,
    Clock1,
    Clock10,
    Clock11,
    Clock12,
    Clock2,
    Clock3,
    Clock4,
    Clock5,
    Clock6,
    Clock7,
    Clock8,
    Clock9,
    Cloud,
    CloudCog,
    CloudDrizzle,
    CloudFog,
    CloudHail,
    CloudLightning,
    CloudMoon,
    CloudMoonRain,
    CloudOff,
    CloudRain,
    CloudRainWind,
    CloudSnow,
    CloudSun,
    CloudSunRain,
    Cloudy,
    Clover,
    Code,
    Code2,
    CodeSquare,
    Codepen,
    Codesandbox,
    Coffee,
    Cog,
    Coins,
    Columns,
    Combine,
    Command,
    Compass,
    Component,
    ConciergeBell,
    Construction,
    Contact,
    Contact2,
    Container,
    Contrast,
    Cookie,
    Copy,
    CopyCheck,
    CopyMinus,
    CopyPlus,
    CopySlash,
    CopyX,
    Copyleft,
    Copyright,
    CornerDownLeft,
    CornerDownRight,
    CornerLeftDown,
    CornerLeftUp,
    CornerRightDown,
    CornerRightUp,
    CornerUpLeft,
    CornerUpRight,
    Cpu,
    CreativeCommons,
    CreditCard,
    Croissant,
    Crop,
    Cross,
    Crosshair,
    Crown,
    CupSoda,
    Currency,
    Database,
    DatabaseBackup,
    Delete,
    Diamond,
    Dice1,
    Dice2,
    Dice3,
    Dice4,
    Dice5,
    Dice6,
    Dices,
    Diff,
    Disc,
    Disc2,
    Disc3,
    Divide,
    DivideCircle,
    DivideSquare,
    Dna,
    DnaOff,
    Dog,
    DollarSign,
    Donut,
    DoorClosed,
    DoorOpen,
    Dot,
    Download,
    DownloadCloud,
    Dribbble,
    Droplet,
    Droplets,
    Drumstick,
    Dumbbell,
    Ear,
    EarOff,
    Edit,
    Edit2,
    Edit3,
    Egg,
    EggFried,
    EggOff,
    Equal,
    EqualNot,
    Eraser,
    Euro,
    Expand,
    ExternalLink,
    Eye,
    EyeOff,
    Facebook,
    Factory,
    Fan,
    FastForward,
    Feather,
    FerrisWheel,
    Figma,
    File,
    FileArchive,
    FileAudio,
    FileAudio2,
    FileAxis3D,
    FileBadge,
    FileBadge2,
    FileBarChart,
    FileBarChart2,
    FileBox,
    FileCheck,
    FileCheck2,
    FileClock,
    FileCode,
    FileCode2,
    FileCog,
    FileCog2,
    FileDiff,
    FileDigit,
    FileDown,
    FileEdit,
    FileHeart,
    FileImage,
    FileInput,
    FileJson,
    FileJson2,
    FileKey,
    FileKey2,
    FileLineChart,
    FileLock,
    FileLock2,
    FileMinus,
    FileMinus2,
    FileOutput,
    FilePieChart,
    FilePlus,
    FilePlus2,
    FileQuestion,
    FileScan,
    FileSearch,
    FileSearch2,
    FileSignature,
    FileSpreadsheet,
    FileStack,
    FileSymlink,
    FileTerminal,
    FileText,
    FileType,
    FileType2,
    FileUp,
    FileVideo,
    FileVideo2,
    FileVolume,
    FileVolume2,
    FileWarning,
    FileX,
    FileX2,
    Files,
    Film,
    Filter,
    FilterX,
    Fingerprint,
    Fish,
    FishOff,
    Flag,
    FlagOff,
    FlagTriangleLeft,
    FlagTriangleRight,
    Flame,
    Flashlight,
    FlashlightOff,
    FlaskConical,
    FlaskConicalOff,
    FlaskRound,
    FlipHorizontal,
    FlipHorizontal2,
    FlipVertical,
    FlipVertical2,
    Flower,
    Flower2,
    Focus,
    FoldHorizontal,
    FoldVertical,
    Folder,
    FolderArchive,
    FolderCheck,
    FolderClock,
    FolderClosed,
    FolderCog,
    FolderCog2,
    FolderDown,
    FolderEdit,
    FolderGit,
    FolderGit2,
    FolderHeart,
    FolderInput,
    FolderKey,
    FolderLock,
    FolderMinus,
    FolderOpen,
    FolderOutput,
    FolderPlus,
    FolderSearch,
    FolderSearch2,
    FolderSymlink,
    FolderSync,
    FolderTree,
    FolderUp,
    FolderX,
    Folders,
    Footprints,
    Forklift,
    FormInput,
    Forward,
    Frame,
    Framer,
    Frown,
    Fuel,
    FunctionSquare,
    Gamepad,
    Gamepad2,
    Gauge,
    GaugeCircle,
    Gavel,
    Gem,
    Ghost,
    Gift,
    GitBranch,
    GitBranchPlus,
    GitCommit,
    GitCompare,
    GitFork,
    GitMerge,
    GitPullRequest,
    GitPullRequestClosed,
    GitPullRequestDraft,
    Github,
    Gitlab,
    GlassWater,
    Glasses,
    Globe,
    Globe2,
    Grab,
    GraduationCap,
    Grape,
    Grid,
    Grip,
    GripHorizontal,
    GripVertical,
    Group,
    Hammer,
    Hand,
    HandMetal,
    HardDrive,
    HardDriveDownload,
    HardDriveUpload,
    HardHat,
    Hash,
    Haze,
    Heading,
    Heading1,
    Heading2,
    Heading3,
    Heading4,
    Heading5,
    Heading6,
    Headphones,
    Heart,
    HeartCrack,
    HeartHandshake,
    HeartOff,
    HeartPulse,
    HelpCircle,
    HelpingHand,
    Hexagon,
    Highlighter,
    History,
    Home,
    Hop,
    HopOff,
    Hotel,
    Hourglass,
    IceCream,
    IceCream2,
    IconNode,
    Image,
    ImageMinus,
    ImageOff,
    ImagePlus,
    Import,
    Inbox,
    Indent,
    IndianRupee,
    Infinity,
    Info,
    Inspect,
    Instagram,
    Italic,
    IterationCcw,
    IterationCw,
    JapaneseYen,
    Joystick,
    Key,
    KeyRound,
    KeySquare,
    Keyboard,
    Lamp,
    LampCeiling,
    LampDesk,
    LampFloor,
    LampWallDown,
    LampWallUp,
    Landmark,
    Languages,
    Laptop,
    Laptop2,
    Lasso,
    LassoSelect,
    Laugh,
    Layers,
    Layout,
    LayoutDashboard,
    LayoutGrid,
    LayoutList,
    LayoutPanelLeft,
    LayoutPanelTop,
    LayoutTemplate,
    Leaf,
    LeafyGreen,
    Library,
    LifeBuoy,
    Ligature,
    Lightbulb,
    LightbulbOff,
    LineChart,
    Link,
    Link2,
    Link2Off,
    Linkedin,
    List,
    ListChecks,
    ListEnd,
    ListFilter,
    ListMinus,
    ListMusic,
    ListOrdered,
    ListPlus,
    ListRestart,
    ListStart,
    ListTodo,
    ListTree,
    ListVideo,
    ListX,
    Loader,
    Loader2,
    Locate,
    LocateFixed,
    LocateOff,
    Lock,
    LogIn,
    LogOut,
    Lollipop,
    LucideIcon,
    Luggage,
    MSquare,
    Magnet,
    Mail,
    MailCheck,
    MailMinus,
    MailOpen,
    MailPlus,
    MailQuestion,
    MailSearch,
    MailWarning,
    MailX,
    Mailbox,
    Mails,
    Map as MapIcon,
    MapPin,
    MapPinOff,
    Martini,
    Maximize,
    Maximize2,
    Medal,
    Megaphone,
    MegaphoneOff,
    Meh,
    MemoryStick,
    Menu,
    MenuSquare,
    Merge,
    MessageCircle,
    MessageSquare,
    MessageSquareDashed,
    MessageSquarePlus,
    MessagesSquare,
    Mic,
    Mic2,
    MicOff,
    Microscope,
    Microwave,
    Milestone,
    Milk,
    MilkOff,
    Minimize,
    Minimize2,
    Minus,
    MinusCircle,
    MinusSquare,
    Monitor,
    MonitorCheck,
    MonitorDot,
    MonitorDown,
    MonitorOff,
    MonitorPause,
    MonitorPlay,
    MonitorSmartphone,
    MonitorSpeaker,
    MonitorStop,
    MonitorUp,
    MonitorX,
    Moon,
    MoonStar,
    MoreHorizontal,
    MoreVertical,
    Mountain,
    MountainSnow,
    Mouse,
    MousePointer,
    MousePointer2,
    MousePointerClick,
    MousePointerSquareDashed,
    MousePointerSquareDashedIcon,
    Move,
    Move3D,
    MoveDiagonal,
    MoveDiagonal2,
    MoveDown,
    MoveDownLeft,
    MoveDownRight,
    MoveHorizontal,
    MoveLeft,
    MoveRight,
    MoveUp,
    MoveUpLeft,
    MoveUpRight,
    MoveVertical,
    Music,
    Music2,
    Music3,
    Music4,
    Navigation,
    Navigation2,
    Navigation2Off,
    NavigationOff,
    Network,
    Newspaper,
    Nfc,
    Nut,
    NutOff,
    Octagon,
    Option,
    Orbit,
    Outdent,
    Package,
    Package2,
    PackageCheck,
    PackageMinus,
    PackageOpen,
    PackagePlus,
    PackageSearch,
    PackageX,
    PaintBucket,
    Paintbrush,
    Paintbrush2,
    Palette,
    Palmtree,
    PanelBottom,
    PanelBottomClose,
    PanelBottomInactive,
    PanelBottomOpen,
    PanelLeft,
    PanelLeftClose,
    PanelLeftInactive,
    PanelLeftOpen,
    PanelRight,
    PanelRightClose,
    PanelRightInactive,
    PanelRightOpen,
    PanelTop,
    PanelTopClose,
    PanelTopInactive,
    PanelTopOpen,
    Paperclip,
    Parentheses,
    ParkingCircle,
    ParkingCircleOff,
    ParkingMeter,
    ParkingSquare,
    ParkingSquareOff,
    PartyPopper,
    Pause,
    PauseCircle,
    PauseOctagon,
    PawPrint,
    PcCase,
    Pen,
    PenLine,
    PenSquare,
    PenTool,
    Pencil,
    PencilLine,
    PencilRuler,
    Pentagon,
    Percent,
    PersonStanding,
    Phone,
    PhoneCall,
    PhoneForwarded,
    PhoneIncoming,
    PhoneMissed,
    PhoneOff,
    PhoneOutgoing,
    Pi,
    PiSquare,
    PictureInPicture,
    PictureInPicture2,
    PieChart,
    PiggyBank,
    Pilcrow,
    PilcrowSquare,
    Pill,
    Pin,
    PinOff,
    Pipette,
    Pizza,
    Plane,
    PlaneLanding,
    PlaneTakeoff,
    Play,
    PlayCircle,
    PlaySquare,
    Plug,
    Plug2,
    PlugZap,
    PlugZap2,
    Plus,
    PlusCircle,
    PlusSquare,
    Pocket,
    PocketKnife,
    Podcast,
    Pointer,
    Popcorn,
    Popsicle,
    PoundSterling,
    Power,
    PowerOff,
    PowerSquare,
    Presentation,
    Printer,
    Projector,
    Puzzle,
    QrCode,
    Quote,
    Rabbit,
    Radar,
    Radiation,
    Radio,
    RadioReceiver,
    RadioTower,
    RailSymbol,
    Rainbow,
    Rat,
    Ratio,
    Receipt,
    RectangleHorizontal,
    RectangleVertical,
    Recycle,
    Redo,
    RedoDot,
    RefreshCcw,
    RefreshCw,
    Refrigerator,
    Regex,
    RemoveFormatting,
    Repeat,
    Repeat1,
    Repeat2,
    Replace,
    ReplaceAll,
    Reply,
    ReplyAll,
    Rewind,
    Rocket,
    RockingChair,
    RollerCoaster,
    Rotate3D,
    RotateCcw,
    RotateCw,
    Route,
    RouteOff,
    Router,
    Rows,
    Rss,
    Ruler,
    RussianRuble,
    Sailboat,
    Salad,
    Sandwich,
    Satellite,
    SatelliteDish,
    Save,
    SaveAll,
    Scale,
    Scale3D,
    Scaling,
    Scan,
    ScanBarcode,
    ScanEye,
    ScanFace,
    ScanLine,
    ScanSearch,
    ScanText,
    ScatterChart,
    School,
    School2,
    Scissors,
    ScissorsLineDashed,
    ScissorsSquare,
    ScissorsSquareDashedBottom,
    ScreenShare,
    ScreenShareOff,
    Scroll,
    ScrollText,
    Search,
    SearchCheck,
    SearchCode,
    SearchSlash,
    SearchX,
    Send,
    SendHorizonal,
    SendHorizontal,
    SendToBack,
    SeparatorHorizontal,
    SeparatorVertical,
    Server,
    ServerCog,
    ServerCrash,
    ServerOff,
    Settings,
    Settings2,
    Shapes,
    Share,
    Share2,
    Sheet,
    Shield,
    ShieldAlert,
    ShieldBan,
    ShieldCheck,
    ShieldClose,
    ShieldEllipsis,
    ShieldHalf,
    ShieldMinus,
    ShieldOff,
    ShieldPlus,
    ShieldQuestion,
    ShieldX,
    Ship,
    ShipWheel,
    Shirt,
    ShoppingBag,
    ShoppingBasket,
    ShoppingCart,
    Shovel,
    ShowerHead,
    Shrink,
    Shrub,
    Shuffle,
    Sigma,
    SigmaSquare,
    Signal,
    SignalHigh,
    SignalLow,
    SignalMedium,
    SignalZero,
    Signpost,
    SignpostBig,
    Siren,
    SkipBack,
    SkipForward,
    Skull,
    Slack,
    Slash,
    Slice,
    Sliders,
    SlidersHorizontal,
    Smartphone,
    SmartphoneCharging,
    SmartphoneNfc,
    Smile,
    SmilePlus,
    Snail,
    Snowflake,
    Sofa,
    SortAsc,
    SortDesc,
    Soup,
    Space,
    Spade,
    Sparkle,
    Sparkles,
    Speaker,
    SpellCheck,
    SpellCheck2,
    Spline,
    Split,
    SplitSquareHorizontal,
    SplitSquareVertical,
    SprayCan,
    Sprout,
    Square,
    SquareAsterisk,
    SquareCode,
    SquareDashedBottom,
    SquareDot,
    SquareEqual,
    SquareSlash,
    SquareStack,
    Squirrel,
    Stamp,
    Star,
    StarHalf,
    StarOff,
    Stars,
    StepBack,
    StepForward,
    Stethoscope,
    Sticker,
    StickyNote,
    StopCircle,
    Store,
    StretchHorizontal,
    StretchVertical,
    Strikethrough,
    Subscript,
    Subtitles,
    Sun,
    SunDim,
    SunMedium,
    SunMoon,
    SunSnow,
    Sunrise,
    Sunset,
    Superscript,
    SwissFranc,
    SwitchCamera,
    Sword,
    Swords,
    Syringe,
    Table,
    Table2,
    Tablet,
    TabletSmartphone,
    Tablets,
    Tag,
    Tags,
    Target,
    Tent,
    Terminal,
    TerminalSquare,
    TestTube,
    TestTube2,
    TestTubes,
    Text,
    TextCursor,
    TextCursorInput,
    TextQuote,
    TextSelect,
    Theater,
    Thermometer,
    ThermometerSnowflake,
    ThermometerSun,
    ThumbsDown,
    ThumbsUp,
    Ticket,
    Timer,
    TimerOff,
    TimerReset,
    ToggleLeft,
    ToggleRight,
    Tornado,
    Torus,
    Touchpad,
    TouchpadOff,
    TrafficCone,
    Train,
    TrainFront,
    TrainFrontTunnel,
    TrainTrack,
    TramFront,
    Trash,
    Trash2,
    TreeDeciduous,
    TreePine,
    Trees,
    Trello,
    TrendingDown,
    TrendingUp,
    Triangle,
    TriangleRight,
    Trophy,
    Truck,
    Tv,
    Tv2,
    Twitch,
    Twitter,
    Type,
    Umbrella,
    UmbrellaOff,
    Underline,
    Undo,
    Undo2,
    UndoDot,
    UnfoldHorizontal,
    UnfoldVertical,
    Ungroup,
    Unlink,
    Unlink2,
    Unlock,
    UnlockKeyhole,
    Unplug,
    Upload,
    UploadCloud,
    Usb,
    User,
    User2,
    UserCheck,
    UserCheck2,
    UserCircle,
    UserCircle2,
    UserCog,
    UserCog2,
    UserMinus,
    UserMinus2,
    UserPlus,
    UserPlus2,
    UserRound,
    UserRoundCheck,
    UserRoundCog,
    UserRoundMinus,
    UserRoundPlus,
    UserRoundSearch,
    UserRoundX,
    UserSearch,
    UserSquare,
    UserSquare2,
    UserX,
    UserX2,
    Users,
    Users2,
    UsersRound,
    Utensils,
    UtensilsCrossed,
    UtilityPole,
    Variable,
    Vegan,
    VenetianMask,
    Vibrate,
    VibrateOff,
    Video,
    VideoOff,
    View,
    Voicemail,
    Volume,
    Volume1,
    Volume2,
    VolumeX,
    Vote,
    Wallet,
    Wallet2,
    WalletCards,
    Wallpaper,
    Wand,
    Wand2,
    Warehouse,
    Watch,
    Waves,
    Waypoints,
    Webcam,
    Webhook,
    Weight,
    Wheat,
    WheatOff,
    WholeWord,
    Wifi,
    WifiOff,
    Wind,
    Wine,
    WineOff,
    Workflow,
    WrapText,
    Wrench,
    X,
    XCircle,
    XOctagon,
    XSquare,
    Youtube,
    Zap,
    ZapOff,
    ZoomIn,
    ZoomOut,
} from "lucide-react";

export interface IconLucideProps {
    className: string;
    iconName: string;
    color?: string;
}

export function IconLucide({ className, iconName, color }: IconLucideProps) {
    if (!iconName || !lucideIcons.get(iconName)) return null;
    const LucideIcon: LucideIcon = lucideIcons.get(iconName)!;
    return (
        <LucideIcon className={className} color={color} strokeWidth="1.5px" />
    )
}

const lucideIcons: Map<string, LucideIcon> = new Map<string, LucideIcon>([
    ["activity", Activity],
    ["airplay", Airplay],
    ["alarm-check", AlarmCheck],
    ["alarm-clock", AlarmClock],
    ["alarm-clock-off", AlarmClockOff],
    ["alarm-minus", AlarmMinus],
    ["alarm-plus", AlarmPlus],
    ["album", Album],
    ["alert-circle", AlertCircle],
    ["alert-octagon", AlertOctagon],
    ["alert-triangle", AlertTriangle],
    ["align-center", AlignCenter],
    ["align-center-horizontal", AlignCenterHorizontal],
    ["align-center-vertical", AlignCenterVertical],
    ["align-end-horizontal", AlignEndHorizontal],
    ["align-end-vertical", AlignEndVertical],
    ["align-horizontal-distribute-center", AlignHorizontalDistributeCenter],
    ["align-horizontal-distribute-end", AlignHorizontalDistributeEnd],
    ["align-horizontal-distribute-start", AlignHorizontalDistributeStart],
    ["align-horizontal-justify-center", AlignHorizontalJustifyCenter],
    ["align-horizontal-justify-end", AlignHorizontalJustifyEnd],
    ["align-horizontal-justify-start", AlignHorizontalJustifyStart],
    ["align-horizontal-space-around", AlignHorizontalSpaceAround],
    ["align-horizontal-space-between", AlignHorizontalSpaceBetween],
    ["align-justify", AlignJustify],
    ["align-left", AlignLeft],
    ["align-right", AlignRight],
    ["align-start-horizontal", AlignStartHorizontal],
    ["align-start-vertical", AlignStartVertical],
    ["align-vertical-distribute-center", AlignVerticalDistributeCenter],
    ["align-vertical-distribute-end", AlignVerticalDistributeEnd],
    ["align-vertical-distribute-start", AlignVerticalDistributeStart],
    ["align-vertical-justify-center", AlignVerticalJustifyCenter],
    ["align-vertical-justify-end", AlignVerticalJustifyEnd],
    ["align-vertical-justify-start", AlignVerticalJustifyStart],
    ["align-vertical-space-around", AlignVerticalSpaceAround],
    ["align-vertical-space-between", AlignVerticalSpaceBetween],
    ["anchor", Anchor],
    ["angry", Angry],
    ["annoyed", Annoyed],
    ["aperture", Aperture],
    ["app-window", AppWindow],
    ["apple", Apple],
    ["archive", Archive],
    ["archive-restore", ArchiveRestore],
    ["archive-x", ArchiveX],
    ["area-chart", AreaChart],
    ["armchair", Armchair],
    ["arrow-big-down", ArrowBigDown],
    ["arrow-big-down-dash", ArrowBigDownDash],
    ["arrow-big-left", ArrowBigLeft],
    ["arrow-big-left-dash", ArrowBigLeftDash],
    ["arrow-big-right", ArrowBigRight],
    ["arrow-big-right-dash", ArrowBigRightDash],
    ["arrow-big-up", ArrowBigUp],
    ["arrow-big-up-dash", ArrowBigUpDash],
    ["arrow-down", ArrowDown],
    ["arrow-down-01", ArrowDown01],
    ["arrow-down-10", ArrowDown10],
    ["arrow-down-a-z", ArrowDownAZ],
    ["arrow-down-circle", ArrowDownCircle],
    ["arrow-down-from-line", ArrowDownFromLine],
    ["arrow-down-left", ArrowDownLeft],
    ["arrow-down-left-from-circle", ArrowDownLeftFromCircle],
    ["arrow-down-left-square", ArrowDownLeftSquare],
    ["arrow-down-narrow-wide", ArrowDownNarrowWide],
    ["arrow-down-right", ArrowDownRight],
    ["arrow-down-right-from-circle", ArrowDownRightFromCircle],
    ["arrow-down-right-square", ArrowDownRightSquare],
    ["arrow-down-square", ArrowDownSquare],
    ["arrow-down-to-dot", ArrowDownToDot],
    ["arrow-down-to-line", ArrowDownToLine],
    ["arrow-down-up", ArrowDownUp],
    ["arrow-down-wide-narrow", ArrowDownWideNarrow],
    ["arrow-down-z-a", ArrowDownZA],
    ["arrow-left", ArrowLeft],
    ["arrow-left-circle", ArrowLeftCircle],
    ["arrow-left-from-line", ArrowLeftFromLine],
    ["arrow-left-right", ArrowLeftRight],
    ["arrow-left-square", ArrowLeftSquare],
    ["arrow-left-to-line", ArrowLeftToLine],
    ["arrow-right", ArrowRight],
    ["arrow-right-circle", ArrowRightCircle],
    ["arrow-right-from-line", ArrowRightFromLine],
    ["arrow-right-left", ArrowRightLeft],
    ["arrow-right-square", ArrowRightSquare],
    ["arrow-right-to-line", ArrowRightToLine],
    ["arrow-up", ArrowUp],
    ["arrow-up-01", ArrowUp01],
    ["arrow-up-10", ArrowUp10],
    ["arrow-up-a-z", ArrowUpAZ],
    ["arrow-up-circle", ArrowUpCircle],
    ["arrow-up-down", ArrowUpDown],
    ["arrow-up-from-dot", ArrowUpFromDot],
    ["arrow-up-from-line", ArrowUpFromLine],
    ["arrow-up-left", ArrowUpLeft],
    ["arrow-up-left-from-circle", ArrowUpLeftFromCircle],
    ["arrow-up-left-square", ArrowUpLeftSquare],
    ["arrow-up-narrow-wide", ArrowUpNarrowWide],
    ["arrow-up-right", ArrowUpRight],
    ["arrow-up-right-from-circle", ArrowUpRightFromCircle],
    ["arrow-up-right-square", ArrowUpRightSquare],
    ["arrow-up-square", ArrowUpSquare],
    ["arrow-up-to-line", ArrowUpToLine],
    ["arrow-up-wide-narrow", ArrowUpWideNarrow],
    ["arrow-up-z-a", ArrowUpZA],
    ["asterisk", Asterisk],
    ["at-sign", AtSign],
    ["atom", Atom],
    ["award", Award],
    ["axe", Axe],
    ["axis-3d", Axis3D],
    ["baby", Baby],
    ["backpack", Backpack],
    ["badge", Badge],
    ["badge-alert", BadgeAlert],
    ["badge-check", BadgeCheck],
    ["badge-dollar-sign", BadgeDollarSign],
    ["badge-help", BadgeHelp],
    ["badge-info", BadgeInfo],
    ["badge-minus", BadgeMinus],
    ["badge-percent", BadgePercent],
    ["badge-plus", BadgePlus],
    ["badge-x", BadgeX],
    ["baggage-claim", BaggageClaim],
    ["ban", Ban],
    ["banana", Banana],
    ["banknote", Banknote],
    ["bar-chart", BarChart],
    ["bar-chart-2", BarChart2],
    ["bar-chart-3", BarChart3],
    ["bar-chart-4", BarChart4],
    ["bar-chart-big", BarChartBig],
    ["bar-chart-horizontal", BarChartHorizontal],
    ["bar-chart-horizontal-big", BarChartHorizontalBig],
    ["baseline", Baseline],
    ["bath", Bath],
    ["battery", Battery],
    ["battery-charging", BatteryCharging],
    ["battery-full", BatteryFull],
    ["battery-low", BatteryLow],
    ["battery-medium", BatteryMedium],
    ["battery-warning", BatteryWarning],
    ["beaker", Beaker],
    ["bean", Bean],
    ["bean-off", BeanOff],
    ["bed-double", BedDouble],
    ["bed-single", BedSingle],
    ["beef", Beef],
    ["beer", Beer],
    ["bell", Bell],
    ["bell-dot", BellDot],
    ["bell-minus", BellMinus],
    ["bell-off", BellOff],
    ["bell-plus", BellPlus],
    ["bell-ring", BellRing],
    ["bike", Bike],
    ["binary", Binary],
    ["biohazard", Biohazard],
    ["bird", Bird],
    ["bitcoin", Bitcoin],
    ["blinds", Blinds],
    ["blocks", Blocks],
    ["bluetooth", Bluetooth],
    ["bluetooth-connected", BluetoothConnected],
    ["bluetooth-off", BluetoothOff],
    ["bluetooth-searching", BluetoothSearching],
    ["bold", Bold],
    ["bomb", Bomb],
    ["bone", Bone],
    ["book", Book],
    ["book-a", BookA],
    ["book-audio", BookAudio],
    ["book-check", BookCheck],
    ["book-copy", BookCopy],
    ["book-dashed", BookDashed],
    ["book-down", BookDown],
    ["book-headphones", BookHeadphones],
    ["book-heart", BookHeart],
    ["book-image", BookImage],
    ["book-key", BookKey],
    ["book-lock", BookLock],
    ["book-marked", BookMarked],
    ["book-minus", BookMinus],
    ["book-open", BookOpen],
    ["book-open-check", BookOpenCheck],
    ["book-open-text", BookOpenText],
    ["book-plus", BookPlus],
    ["book-template", BookTemplate],
    ["book-text", BookText],
    ["book-type", BookType],
    ["book-up", BookUp],
    ["book-up-2", BookUp2],
    ["book-user", BookUser],
    ["book-x", BookX],
    ["bookmark", Bookmark],
    ["bookmark-check", BookmarkCheck],
    ["bookmark-minus", BookmarkMinus],
    ["bookmark-plus", BookmarkPlus],
    ["bookmark-x", BookmarkX],
    ["bot", Bot],
    ["box", Box],
    ["box-select", BoxSelect],
    ["boxes", Boxes],
    ["braces", Braces],
    ["brackets", Brackets],
    ["brain", Brain],
    ["brain-circuit", BrainCircuit],
    ["brain-cog", BrainCog],
    ["briefcase", Briefcase],
    ["bring-to-front", BringToFront],
    ["brush", Brush],
    ["bug", Bug],
    ["building", Building],
    ["building-2", Building2],
    ["bus", Bus],
    ["bus-front", BusFront],
    ["cable", Cable],
    ["cable-car", CableCar],
    ["cake", Cake],
    ["cake-slice", CakeSlice],
    ["calculator", Calculator],
    ["calendar", Calendar],
    ["calendar-check", CalendarCheck],
    ["calendar-check-2", CalendarCheck2],
    ["calendar-clock", CalendarClock],
    ["calendar-days", CalendarDays],
    ["calendar-heart", CalendarHeart],
    ["calendar-minus", CalendarMinus],
    ["calendar-off", CalendarOff],
    ["calendar-plus", CalendarPlus],
    ["calendar-range", CalendarRange],
    ["calendar-search", CalendarSearch],
    ["calendar-x", CalendarX],
    ["calendar-x-2", CalendarX2],
    ["camera", Camera],
    ["camera-off", CameraOff],
    ["candlestick-chart", CandlestickChart],
    ["candy", Candy],
    ["candy-cane", CandyCane],
    ["candy-off", CandyOff],
    ["car", Car],
    ["car-front", CarFront],
    ["car-taxi-front", CarTaxiFront],
    ["carrot", Carrot],
    ["case-lower", CaseLower],
    ["case-sensitive", CaseSensitive],
    ["case-upper", CaseUpper],
    ["cast", Cast],
    ["castle", Castle],
    ["cat", Cat],
    ["check", Check],
    ["check-check", CheckCheck],
    ["check-circle", CheckCircle],
    ["check-circle-2", CheckCircle2],
    ["check-square", CheckSquare],
    ["chef-hat", ChefHat],
    ["cherry", Cherry],
    ["chevron-down", ChevronDown],
    ["chevron-down-square", ChevronDownSquare],
    ["chevron-first", ChevronFirst],
    ["chevron-last", ChevronLast],
    ["chevron-left", ChevronLeft],
    ["chevron-left-square", ChevronLeftSquare],
    ["chevron-right", ChevronRight],
    ["chevron-right-square", ChevronRightSquare],
    ["chevron-up", ChevronUp],
    ["chevron-up-square", ChevronUpSquare],
    ["chevrons-down", ChevronsDown],
    ["chevrons-down-up", ChevronsDownUp],
    ["chevrons-left", ChevronsLeft],
    ["chevrons-left-right", ChevronsLeftRight],
    ["chevrons-right", ChevronsRight],
    ["chevrons-right-left", ChevronsRightLeft],
    ["chevrons-up", ChevronsUp],
    ["chevrons-up-down", ChevronsUpDown],
    ["chrome", Chrome],
    ["church", Church],
    ["cigarette", Cigarette],
    ["cigarette-off", CigaretteOff],
    ["circle", Circle],
    ["circle-dashed", CircleDashed],
    ["circle-dollar-sign", CircleDollarSign],
    ["circle-dot", CircleDot],
    ["circle-dot-dashed", CircleDotDashed],
    ["circle-ellipsis", CircleEllipsis],
    ["circle-equal", CircleEqual],
    ["circle-off", CircleOff],
    ["circle-slash", CircleSlash],
    ["circle-slash-2", CircleSlash2],
    ["circle-user", CircleUser],
    ["circle-user-round", CircleUserRound],
    ["circuit-board", CircuitBoard],
    ["citrus", Citrus],
    ["clapperboard", Clapperboard],
    ["clipboard", Clipboard],
    ["clipboard-check", ClipboardCheck],
    ["clipboard-copy", ClipboardCopy],
    ["clipboard-edit", ClipboardEdit],
    ["clipboard-list", ClipboardList],
    ["clipboard-paste", ClipboardPaste],
    ["clipboard-signature", ClipboardSignature],
    ["clipboard-type", ClipboardType],
    ["clipboard-x", ClipboardX],
    ["clock", Clock],
    ["clock-1", Clock1],
    ["clock-10", Clock10],
    ["clock-11", Clock11],
    ["clock-12", Clock12],
    ["clock-2", Clock2],
    ["clock-3", Clock3],
    ["clock-4", Clock4],
    ["clock-5", Clock5],
    ["clock-6", Clock6],
    ["clock-7", Clock7],
    ["clock-8", Clock8],
    ["clock-9", Clock9],
    ["cloud", Cloud],
    ["cloud-cog", CloudCog],
    ["cloud-drizzle", CloudDrizzle],
    ["cloud-fog", CloudFog],
    ["cloud-hail", CloudHail],
    ["cloud-lightning", CloudLightning],
    ["cloud-moon", CloudMoon],
    ["cloud-moon-rain", CloudMoonRain],
    ["cloud-off", CloudOff],
    ["cloud-rain", CloudRain],
    ["cloud-rain-wind", CloudRainWind],
    ["cloud-snow", CloudSnow],
    ["cloud-sun", CloudSun],
    ["cloud-sun-rain", CloudSunRain],
    ["cloudy", Cloudy],
    ["clover", Clover],
    ["code", Code],
    ["code-2", Code2],
    ["code-square", CodeSquare],
    ["codepen", Codepen],
    ["codesandbox", Codesandbox],
    ["coffee", Coffee],
    ["cog", Cog],
    ["coins", Coins],
    ["columns", Columns],
    ["combine", Combine],
    ["command", Command],
    ["compass", Compass],
    ["component", Component],
    ["concierge-bell", ConciergeBell],
    ["construction", Construction],
    ["contact", Contact],
    ["contact-2", Contact2],
    ["container", Container],
    ["contrast", Contrast],
    ["cookie", Cookie],
    ["copy", Copy],
    ["copy-check", CopyCheck],
    ["copy-minus", CopyMinus],
    ["copy-plus", CopyPlus],
    ["copy-slash", CopySlash],
    ["copy-x", CopyX],
    ["copyleft", Copyleft],
    ["copyright", Copyright],
    ["corner-down-left", CornerDownLeft],
    ["corner-down-right", CornerDownRight],
    ["corner-left-down", CornerLeftDown],
    ["corner-left-up", CornerLeftUp],
    ["corner-right-down", CornerRightDown],
    ["corner-right-up", CornerRightUp],
    ["corner-up-left", CornerUpLeft],
    ["corner-up-right", CornerUpRight],
    ["cpu", Cpu],
    ["creative-commons", CreativeCommons],
    ["credit-card", CreditCard],
    ["croissant", Croissant],
    ["crop", Crop],
    ["cross", Cross],
    ["crosshair", Crosshair],
    ["crown", Crown],
    ["cup-soda", CupSoda],
    ["currency", Currency],
    ["database", Database],
    ["database-backup", DatabaseBackup],
    ["delete", Delete],
    ["diamond", Diamond],
    ["dice-1", Dice1],
    ["dice-2", Dice2],
    ["dice-3", Dice3],
    ["dice-4", Dice4],
    ["dice-5", Dice5],
    ["dice-6", Dice6],
    ["dices", Dices],
    ["diff", Diff],
    ["disc", Disc],
    ["disc-2", Disc2],
    ["disc-3", Disc3],
    ["divide", Divide],
    ["divide-circle", DivideCircle],
    ["divide-square", DivideSquare],
    ["dna", Dna],
    ["dna-off", DnaOff],
    ["dog", Dog],
    ["dollar-sign", DollarSign],
    ["donut", Donut],
    ["door-closed", DoorClosed],
    ["door-open", DoorOpen],
    ["dot", Dot],
    ["download", Download],
    ["download-cloud", DownloadCloud],
    ["dribbble", Dribbble],
    ["droplet", Droplet],
    ["droplets", Droplets],
    ["drumstick", Drumstick],
    ["dumbbell", Dumbbell],
    ["ear", Ear],
    ["ear-off", EarOff],
    ["edit", Edit],
    ["edit-2", Edit2],
    ["edit-3", Edit3],
    ["egg", Egg],
    ["egg-fried", EggFried],
    ["egg-off", EggOff],
    ["equal", Equal],
    ["equal-not", EqualNot],
    ["eraser", Eraser],
    ["euro", Euro],
    ["expand", Expand],
    ["external-link", ExternalLink],
    ["eye", Eye],
    ["eye-off", EyeOff],
    ["facebook", Facebook],
    ["factory", Factory],
    ["fan", Fan],
    ["fast-forward", FastForward],
    ["feather", Feather],
    ["ferris-wheel", FerrisWheel],
    ["figma", Figma],
    ["file", File],
    ["file-archive", FileArchive],
    ["file-audio", FileAudio],
    ["file-audio-2", FileAudio2],
    ["file-axis-3d", FileAxis3D],
    ["file-badge", FileBadge],
    ["file-badge-2", FileBadge2],
    ["file-bar-chart", FileBarChart],
    ["file-bar-chart-2", FileBarChart2],
    ["file-box", FileBox],
    ["file-check", FileCheck],
    ["file-check-2", FileCheck2],
    ["file-clock", FileClock],
    ["file-code", FileCode],
    ["file-code-2", FileCode2],
    ["file-cog", FileCog],
    ["file-cog-2", FileCog2],
    ["file-diff", FileDiff],
    ["file-digit", FileDigit],
    ["file-down", FileDown],
    ["file-edit", FileEdit],
    ["file-heart", FileHeart],
    ["file-image", FileImage],
    ["file-input", FileInput],
    ["file-json", FileJson],
    ["file-json-2", FileJson2],
    ["file-key", FileKey],
    ["file-key-2", FileKey2],
    ["file-line-chart", FileLineChart],
    ["file-lock", FileLock],
    ["file-lock-2", FileLock2],
    ["file-minus", FileMinus],
    ["file-minus-2", FileMinus2],
    ["file-output", FileOutput],
    ["file-pie-chart", FilePieChart],
    ["file-plus", FilePlus],
    ["file-plus-2", FilePlus2],
    ["file-question", FileQuestion],
    ["file-scan", FileScan],
    ["file-search", FileSearch],
    ["file-search-2", FileSearch2],
    ["file-signature", FileSignature],
    ["file-spreadsheet", FileSpreadsheet],
    ["file-stack", FileStack],
    ["file-symlink", FileSymlink],
    ["file-terminal", FileTerminal],
    ["file-text", FileText],
    ["file-type", FileType],
    ["file-type-2", FileType2],
    ["file-up", FileUp],
    ["file-video", FileVideo],
    ["file-video-2", FileVideo2],
    ["file-volume", FileVolume],
    ["file-volume-2", FileVolume2],
    ["file-warning", FileWarning],
    ["file-x", FileX],
    ["file-x-2", FileX2],
    ["files", Files],
    ["film", Film],
    ["filter", Filter],
    ["filter-x", FilterX],
    ["fingerprint", Fingerprint],
    ["fish", Fish],
    ["fish-off", FishOff],
    ["flag", Flag],
    ["flag-off", FlagOff],
    ["flag-triangle-left", FlagTriangleLeft],
    ["flag-triangle-right", FlagTriangleRight],
    ["flame", Flame],
    ["flashlight", Flashlight],
    ["flashlight-off", FlashlightOff],
    ["flask-conical", FlaskConical],
    ["flask-conical-off", FlaskConicalOff],
    ["flask-round", FlaskRound],
    ["flip-horizontal", FlipHorizontal],
    ["flip-horizontal-2", FlipHorizontal2],
    ["flip-vertical", FlipVertical],
    ["flip-vertical-2", FlipVertical2],
    ["flower", Flower],
    ["flower-2", Flower2],
    ["focus", Focus],
    ["fold-horizontal", FoldHorizontal],
    ["fold-vertical", FoldVertical],
    ["folder", Folder],
    ["folder-archive", FolderArchive],
    ["folder-check", FolderCheck],
    ["folder-clock", FolderClock],
    ["folder-closed", FolderClosed],
    ["folder-cog", FolderCog],
    ["folder-cog-2", FolderCog2],
    ["folder-down", FolderDown],
    ["folder-edit", FolderEdit],
    ["folder-git", FolderGit],
    ["folder-git-2", FolderGit2],
    ["folder-heart", FolderHeart],
    ["folder-input", FolderInput],
    ["folder-key", FolderKey],
    ["folder-lock", FolderLock],
    ["folder-minus", FolderMinus],
    ["folder-open", FolderOpen],
    ["folder-output", FolderOutput],
    ["folder-plus", FolderPlus],
    ["folder-search", FolderSearch],
    ["folder-search-2", FolderSearch2],
    ["folder-symlink", FolderSymlink],
    ["folder-sync", FolderSync],
    ["folder-tree", FolderTree],
    ["folder-up", FolderUp],
    ["folder-x", FolderX],
    ["folders", Folders],
    ["footprints", Footprints],
    ["forklift", Forklift],
    ["form-input", FormInput],
    ["forward", Forward],
    ["frame", Frame],
    ["framer", Framer],
    ["frown", Frown],
    ["fuel", Fuel],
    ["function-square", FunctionSquare],
    ["gamepad", Gamepad],
    ["gamepad-2", Gamepad2],
    ["gauge", Gauge],
    ["gauge-circle", GaugeCircle],
    ["gavel", Gavel],
    ["gem", Gem],
    ["ghost", Ghost],
    ["gift", Gift],
    ["git-branch", GitBranch],
    ["git-branch-plus", GitBranchPlus],
    ["git-commit", GitCommit],
    ["git-compare", GitCompare],
    ["git-fork", GitFork],
    ["git-merge", GitMerge],
    ["git-pull-request", GitPullRequest],
    ["git-pull-request-closed", GitPullRequestClosed],
    ["git-pull-request-draft", GitPullRequestDraft],
    ["github", Github],
    ["gitlab", Gitlab],
    ["glass-water", GlassWater],
    ["glasses", Glasses],
    ["globe", Globe],
    ["globe-2", Globe2],
    ["grab", Grab],
    ["graduation-cap", GraduationCap],
    ["grape", Grape],
    ["grid", Grid],
    ["grip", Grip],
    ["grip-horizontal", GripHorizontal],
    ["grip-vertical", GripVertical],
    ["group", Group],
    ["hammer", Hammer],
    ["hand", Hand],
    ["hand-metal", HandMetal],
    ["hard-drive", HardDrive],
    ["hard-drive-download", HardDriveDownload],
    ["hard-drive-upload", HardDriveUpload],
    ["hard-hat", HardHat],
    ["hash", Hash],
    ["haze", Haze],
    ["heading", Heading],
    ["heading-1", Heading1],
    ["heading-2", Heading2],
    ["heading-3", Heading3],
    ["heading-4", Heading4],
    ["heading-5", Heading5],
    ["heading-6", Heading6],
    ["headphones", Headphones],
    ["heart", Heart],
    ["heart-crack", HeartCrack],
    ["heart-handshake", HeartHandshake],
    ["heart-off", HeartOff],
    ["heart-pulse", HeartPulse],
    ["help-circle", HelpCircle],
    ["helping-hand", HelpingHand],
    ["hexagon", Hexagon],
    ["highlighter", Highlighter],
    ["history", History],
    ["home", Home],
    ["hop", Hop],
    ["hop-off", HopOff],
    ["hotel", Hotel],
    ["hourglass", Hourglass],
    ["ice-cream", IceCream],
    ["ice-cream-2", IceCream2],
    ["image", Image],
    ["image-minus", ImageMinus],
    ["image-off", ImageOff],
    ["image-plus", ImagePlus],
    ["import", Import],
    ["inbox", Inbox],
    ["indent", Indent],
    ["indian-rupee", IndianRupee],
    ["infinity", Infinity],
    ["info", Info],
    ["inspect", Inspect],
    ["instagram", Instagram],
    ["italic", Italic],
    ["iteration-ccw", IterationCcw],
    ["iteration-cw", IterationCw],
    ["japanese-yen", JapaneseYen],
    ["joystick", Joystick],
    ["key", Key],
    ["key-round", KeyRound],
    ["key-square", KeySquare],
    ["keyboard", Keyboard],
    ["lamp", Lamp],
    ["lamp-ceiling", LampCeiling],
    ["lamp-desk", LampDesk],
    ["lamp-floor", LampFloor],
    ["lamp-wall-down", LampWallDown],
    ["lamp-wall-up", LampWallUp],
    ["landmark", Landmark],
    ["languages", Languages],
    ["laptop", Laptop],
    ["laptop-2", Laptop2],
    ["lasso", Lasso],
    ["lasso-select", LassoSelect],
    ["laugh", Laugh],
    ["layers", Layers],
    ["layout", Layout],
    ["layout-dashboard", LayoutDashboard],
    ["layout-grid", LayoutGrid],
    ["layout-list", LayoutList],
    ["layout-panel-left", LayoutPanelLeft],
    ["layout-panel-top", LayoutPanelTop],
    ["layout-template", LayoutTemplate],
    ["leaf", Leaf],
    ["leafy-green", LeafyGreen],
    ["library", Library],
    ["life-buoy", LifeBuoy],
    ["ligature", Ligature],
    ["lightbulb", Lightbulb],
    ["lightbulb-off", LightbulbOff],
    ["line-chart", LineChart],
    ["link", Link],
    ["link-2", Link2],
    ["link-2-off", Link2Off],
    ["linkedin", Linkedin],
    ["list", List],
    ["list-checks", ListChecks],
    ["list-end", ListEnd],
    ["list-filter", ListFilter],
    ["list-minus", ListMinus],
    ["list-music", ListMusic],
    ["list-ordered", ListOrdered],
    ["list-plus", ListPlus],
    ["list-restart", ListRestart],
    ["list-start", ListStart],
    ["list-todo", ListTodo],
    ["list-tree", ListTree],
    ["list-video", ListVideo],
    ["list-x", ListX],
    ["loader", Loader],
    ["loader-2", Loader2],
    ["locate", Locate],
    ["locate-fixed", LocateFixed],
    ["locate-off", LocateOff],
    ["lock", Lock],
    ["log-in", LogIn],
    ["log-out", LogOut],
    ["lollipop", Lollipop],
    ["luggage", Luggage],
    ["m-square", MSquare],
    ["magnet", Magnet],
    ["mail", Mail],
    ["mail-check", MailCheck],
    ["mail-minus", MailMinus],
    ["mail-open", MailOpen],
    ["mail-plus", MailPlus],
    ["mail-question", MailQuestion],
    ["mail-search", MailSearch],
    ["mail-warning", MailWarning],
    ["mail-x", MailX],
    ["mailbox", Mailbox],
    ["mails", Mails],
    ["map", MapIcon],
    ["map-pin", MapPin],
    ["map-pin-off", MapPinOff],
    ["martini", Martini],
    ["maximize", Maximize],
    ["maximize-2", Maximize2],
    ["medal", Medal],
    ["megaphone", Megaphone],
    ["megaphone-off", MegaphoneOff],
    ["meh", Meh],
    ["memory-stick", MemoryStick],
    ["menu", Menu],
    ["menu-square", MenuSquare],
    ["merge", Merge],
    ["message-circle", MessageCircle],
    ["message-square", MessageSquare],
    ["message-square-dashed", MessageSquareDashed],
    ["message-square-plus", MessageSquarePlus],
    ["messages-square", MessagesSquare],
    ["mic", Mic],
    ["mic-2", Mic2],
    ["mic-off", MicOff],
    ["microscope", Microscope],
    ["microwave", Microwave],
    ["milestone", Milestone],
    ["milk", Milk],
    ["milk-off", MilkOff],
    ["minimize", Minimize],
    ["minimize-2", Minimize2],
    ["minus", Minus],
    ["minus-circle", MinusCircle],
    ["minus-square", MinusSquare],
    ["monitor", Monitor],
    ["monitor-check", MonitorCheck],
    ["monitor-dot", MonitorDot],
    ["monitor-down", MonitorDown],
    ["monitor-off", MonitorOff],
    ["monitor-pause", MonitorPause],
    ["monitor-play", MonitorPlay],
    ["monitor-smartphone", MonitorSmartphone],
    ["monitor-speaker", MonitorSpeaker],
    ["monitor-stop", MonitorStop],
    ["monitor-up", MonitorUp],
    ["monitor-x", MonitorX],
    ["moon", Moon],
    ["moon-star", MoonStar],
    ["more-horizontal", MoreHorizontal],
    ["more-vertical", MoreVertical],
    ["mountain", Mountain],
    ["mountain-snow", MountainSnow],
    ["mouse", Mouse],
    ["mouse-pointer", MousePointer],
    ["mouse-pointer-2", MousePointer2],
    ["mouse-pointer-click", MousePointerClick],
    ["mouse-pointer-square-dashed", MousePointerSquareDashed],
    ["move", Move],
    ["move-3d", Move3D],
    ["move-diagonal", MoveDiagonal],
    ["move-diagonal-2", MoveDiagonal2],
    ["move-down", MoveDown],
    ["move-down-left", MoveDownLeft],
    ["move-down-right", MoveDownRight],
    ["move-horizontal", MoveHorizontal],
    ["move-left", MoveLeft],
    ["move-right", MoveRight],
    ["move-up", MoveUp],
    ["move-up-left", MoveUpLeft],
    ["move-up-right", MoveUpRight],
    ["move-vertical", MoveVertical],
    ["music", Music],
    ["music-2", Music2],
    ["music-3", Music3],
    ["music-4", Music4],
    ["navigation", Navigation],
    ["navigation-2", Navigation2],
    ["navigation-2-off", Navigation2Off],
    ["navigation-off", NavigationOff],
    ["network", Network],
    ["newspaper", Newspaper],
    ["nfc", Nfc],
    ["nut", Nut],
    ["nut-off", NutOff],
    ["octagon", Octagon],
    ["option", Option],
    ["orbit", Orbit],
    ["outdent", Outdent],
    ["package", Package],
    ["package-2", Package2],
    ["package-check", PackageCheck],
    ["package-minus", PackageMinus],
    ["package-open", PackageOpen],
    ["package-plus", PackagePlus],
    ["package-search", PackageSearch],
    ["package-x", PackageX],
    ["paint-bucket", PaintBucket],
    ["paintbrush", Paintbrush],
    ["paintbrush-2", Paintbrush2],
    ["palette", Palette],
    ["palmtree", Palmtree],
    ["panel-bottom", PanelBottom],
    ["panel-bottom-close", PanelBottomClose],
    ["panel-bottom-inactive", PanelBottomInactive],
    ["panel-bottom-open", PanelBottomOpen],
    ["panel-left", PanelLeft],
    ["panel-left-close", PanelLeftClose],
    ["panel-left-inactive", PanelLeftInactive],
    ["panel-left-open", PanelLeftOpen],
    ["panel-right", PanelRight],
    ["panel-right-close", PanelRightClose],
    ["panel-right-inactive", PanelRightInactive],
    ["panel-right-open", PanelRightOpen],
    ["panel-top", PanelTop],
    ["panel-top-close", PanelTopClose],
    ["panel-top-inactive", PanelTopInactive],
    ["panel-top-open", PanelTopOpen],
    ["paperclip", Paperclip],
    ["parentheses", Parentheses],
    ["parking-circle", ParkingCircle],
    ["parking-circle-off", ParkingCircleOff],
    ["parking-meter", ParkingMeter],
    ["parking-square", ParkingSquare],
    ["parking-square-off", ParkingSquareOff],
    ["party-popper", PartyPopper],
    ["pause", Pause],
    ["pause-circle", PauseCircle],
    ["pause-octagon", PauseOctagon],
    ["paw-print", PawPrint],
    ["pc-case", PcCase],
    ["pen", Pen],
    ["pen-line", PenLine],
    ["pen-square", PenSquare],
    ["pen-tool", PenTool],
    ["pencil", Pencil],
    ["pencil-line", PencilLine],
    ["pencil-ruler", PencilRuler],
    ["pentagon", Pentagon],
    ["percent", Percent],
    ["person-standing", PersonStanding],
    ["phone", Phone],
    ["phone-call", PhoneCall],
    ["phone-forwarded", PhoneForwarded],
    ["phone-incoming", PhoneIncoming],
    ["phone-missed", PhoneMissed],
    ["phone-off", PhoneOff],
    ["phone-outgoing", PhoneOutgoing],
    ["pi", Pi],
    ["pi-square", PiSquare],
    ["picture-in-picture", PictureInPicture],
    ["picture-in-picture-2", PictureInPicture2],
    ["pie-chart", PieChart],
    ["piggy-bank", PiggyBank],
    ["pilcrow", Pilcrow],
    ["pilcrow-square", PilcrowSquare],
    ["pill", Pill],
    ["pin", Pin],
    ["pin-off", PinOff],
    ["pipette", Pipette],
    ["pizza", Pizza],
    ["plane", Plane],
    ["plane-landing", PlaneLanding],
    ["plane-takeoff", PlaneTakeoff],
    ["play", Play],
    ["play-circle", PlayCircle],
    ["play-square", PlaySquare],
    ["plug", Plug],
    ["plug-2", Plug2],
    ["plug-zap", PlugZap],
    ["plug-zap-2", PlugZap2],
    ["plus", Plus],
    ["plus-circle", PlusCircle],
    ["plus-square", PlusSquare],
    ["pocket", Pocket],
    ["pocket-knife", PocketKnife],
    ["podcast", Podcast],
    ["pointer", Pointer],
    ["popcorn", Popcorn],
    ["popsicle", Popsicle],
    ["pound-sterling", PoundSterling],
    ["power", Power],
    ["power-off", PowerOff],
    ["power-square", PowerSquare],
    ["presentation", Presentation],
    ["printer", Printer],
    ["projector", Projector],
    ["puzzle", Puzzle],
    ["qr-code", QrCode],
    ["quote", Quote],
    ["rabbit", Rabbit],
    ["radar", Radar],
    ["radiation", Radiation],
    ["radio", Radio],
    ["radio-receiver", RadioReceiver],
    ["radio-tower", RadioTower],
    ["rail-symbol", RailSymbol],
    ["rainbow", Rainbow],
    ["rat", Rat],
    ["ratio", Ratio],
    ["receipt", Receipt],
    ["rectangle-horizontal", RectangleHorizontal],
    ["rectangle-vertical", RectangleVertical],
    ["recycle", Recycle],
    ["redo", Redo],
    ["redo-dot", RedoDot],
    ["refresh-ccw", RefreshCcw],
    ["refresh-cw", RefreshCw],
    ["refrigerator", Refrigerator],
    ["regex", Regex],
    ["remove-formatting", RemoveFormatting],
    ["repeat", Repeat],
    ["repeat-1", Repeat1],
    ["replace", Replace],
    ["replace-all", ReplaceAll],
    ["reply", Reply],
    ["reply-all", ReplyAll],
    ["rewind", Rewind],
    ["rocket", Rocket],
    ["rocking-chair", RockingChair],
    ["rotate-3d", Rotate3D],
    ["rotate-ccw", RotateCcw],
    ["rotate-cw", RotateCw],
    ["router", Router],
    ["rows", Rows],
    ["rss", Rss],
    ["ruler", Ruler],
    ["russian-ruble", RussianRuble],
    ["sailboat", Sailboat],
    ["salad", Salad],
    ["sandwich", Sandwich],
    ["satellite", Satellite],
    ["satellite-dish", SatelliteDish],
    ["save", Save],
    ["save-all", SaveAll],
    ["scale", Scale],
    ["scale-3d", Scale3D],
    ["scaling", Scaling],
    ["scan", Scan],
    ["scan-face", ScanFace],
    ["scan-line", ScanLine],
    ["scan-search", ScanSearch],
    ["scan-text", ScanText],
    ["scissors", Scissors],
    ["scissors-line-dashed", ScissorsLineDashed],
    ["scissors-square", ScissorsSquare],
    ["scissors-square-dashed-bottom", ScissorsSquareDashedBottom],
    ["screen-share", ScreenShare],
    ["screen-share-off", ScreenShareOff],
    ["scroll", Scroll],
    ["scroll-text", ScrollText],
    ["search", Search],
    ["search-code", SearchCode],
    ["search-slash", SearchSlash],
    ["search-x", SearchX],
    ["send", Send],
    ["send-horizontal", SendHorizontal],
    ["send-to-back", SendToBack],
    ["separator-horizontal", SeparatorHorizontal],
    ["separator-vertical", SeparatorVertical],
    ["server", Server],
    ["server-cog", ServerCog],
    ["server-crash", ServerCrash],
    ["server-off", ServerOff],
    ["settings", Settings],
    ["settings-2", Settings2],
    ["shapes", Shapes],
    ["share", Share],
    ["share-2", Share2],
    ["sheet", Sheet],
    ["shield", Shield],
    ["shield-alert", ShieldAlert],
    ["shield-ban", ShieldBan],
    ["shield-check", ShieldCheck],
    ["shield-ellipsis", ShieldEllipsis],
    ["shield-half", ShieldHalf],
    ["shield-minus", ShieldMinus],
    ["shield-off", ShieldOff],
    ["shield-plus", ShieldPlus],
    ["shield-question", ShieldQuestion],
    ["shield-x", ShieldX],
    ["ship", Ship],
    ["shirt", Shirt],
    ["shopping-bag", ShoppingBag],
    ["shopping-basket", ShoppingBasket],
    ["shopping-cart", ShoppingCart],
    ["shovel", Shovel],
    ["shower-head", ShowerHead],
    ["shrink", Shrink],
    ["shrub", Shrub],
    ["shuffle", Shuffle],
    ["sigma", Sigma],
    ["sigma-square", SigmaSquare],
    ["signal", Signal],
    ["signal-high", SignalHigh],
    ["signal-low", SignalLow],
    ["signal-medium", SignalMedium],
    ["signal-zero", SignalZero],
    ["signpost", Signpost],
    ["signpost-big", SignpostBig],
    ["siren", Siren],
    ["skip-back", SkipBack],
    ["skip-forward", SkipForward],
    ["skull", Skull],
    ["slack", Slack],
    ["slash", Slash],
    ["slice", Slice],
    ["sliders", Sliders],
    ["sliders-horizontal", SlidersHorizontal],
    ["smartphone", Smartphone],
    ["smartphone-charging", SmartphoneCharging],
    ["smartphone-nfc", SmartphoneNfc],
    ["smile", Smile],
    ["smile-plus", SmilePlus],
    ["snail", Snail],
    ["snowflake", Snowflake],
    ["sofa", Sofa],
    ["sort-asc", SortAsc],
    ["sort-desc", SortDesc],
    ["soup", Soup],
    ["space", Space],
    ["spade", Spade],
    ["sparkle", Sparkle],
    ["sparkles", Sparkles],
    ["speaker", Speaker],
    ["spell-check", SpellCheck],
    ["spell-check-2", SpellCheck2],
    ["spline", Spline],
    ["split", Split],
    ["split-square-horizontal", SplitSquareHorizontal],
    ["split-square-vertical", SplitSquareVertical],
    ["spray-can", SprayCan],
    ["sprout", Sprout],
    ["square", Square],
    ["square-asterisk", SquareAsterisk],
    ["square-code", SquareCode],
    ["square-dashed-bottom", SquareDashedBottom],
    ["square-dot", SquareDot],
    ["square-equal", SquareEqual],
    ["square-slash", SquareSlash],
    ["square-stack", SquareStack],
    ["squirrel", Squirrel],
    ["stamp", Stamp],
    ["star", Star],
    ["star-half", StarHalf],
    ["star-off", StarOff],
    ["stars", Stars],
    ["step-back", StepBack],
    ["step-forward", StepForward],
    ["stethoscope", Stethoscope],
    ["sticker", Sticker],
    ["sticky-note", StickyNote],
    ["stop-circle", StopCircle],
    ["store", Store],
    ["stretch-horizontal", StretchHorizontal],
    ["stretch-vertical", StretchVertical],
    ["strikethrough", Strikethrough],
    ["subscript", Subscript],
    ["subtitles", Subtitles],
    ["sun", Sun],
    ["sun-dim", SunDim],
    ["sun-medium", SunMedium],
    ["sun-moon", SunMoon],
    ["sun-snow", SunSnow],
    ["sunrise", Sunrise],
    ["sunset", Sunset],
    ["superscript", Superscript],
    ["swiss-franc", SwissFranc],
    ["switch-camera", SwitchCamera],
    ["sword", Sword],
    ["swords", Swords],
    ["syringe", Syringe],
    ["table", Table],
    ["table-2", Table2],
    ["tablet", Tablet],
    ["tablet-smartphone", TabletSmartphone],
    ["tablets", Tablets],
    ["tag", Tag],
    ["tags", Tags],
    ["target", Target],
    ["tent", Tent],
    ["terminal", Terminal],
    ["terminal-square", TerminalSquare],
    ["test-tube", TestTube],
    ["test-tube-2", TestTube2],
    ["test-tubes", TestTubes],
    ["text", Text],
    ["text-cursor", TextCursor],
    ["text-cursor-input", TextCursorInput],
    ["text-quote", TextQuote],
    ["text-select", TextSelect],
    ["theater", Theater],
    ["thermometer", Thermometer],
    ["thermometer-snowflake", ThermometerSnowflake],
    ["thermometer-sun", ThermometerSun],
    ["thumbs-down", ThumbsDown],
    ["thumbs-up", ThumbsUp],
    ["ticket", Ticket],
    ["timer", Timer],
    ["timer-off", TimerOff],
    ["timer-reset", TimerReset],
    ["toggle-left", ToggleLeft],
    ["toggle-right", ToggleRight],
    ["tornado", Tornado],
    ["torus", Torus],
    ["touchpad", Touchpad],
    ["touchpad-off", TouchpadOff],
    ["traffic-cone", TrafficCone],
    ["train", Train],
    ["train-front", TrainFront],
    ["train-front-tunnel", TrainFrontTunnel],
    ["train-track", TrainTrack],
    ["tram-front", TramFront],
    ["trash", Trash],
    ["trash-2", Trash2],
    ["tree-deciduous", TreeDeciduous],
    ["tree-pine", TreePine],
    ["trees", Trees],
    ["trello", Trello],
    ["trending-down", TrendingDown],
    ["trending-up", TrendingUp],
    ["triangle", Triangle],
    ["triangle-right", TriangleRight],
    ["trophy", Trophy],
    ["truck", Truck],
    ["tv", Tv],
    ["tv-2", Tv2],
    ["twitch", Twitch],
    ["twitter", Twitter],
    ["type", Type],
    ["umbrella", Umbrella],
    ["umbrella-off", UmbrellaOff],
    ["underline", Underline],
    ["undo", Undo],
    ["undo-2", Undo2],
    ["undo-dot", UndoDot],
    ["unfold-horizontal", UnfoldHorizontal],
    ["unfold-vertical", UnfoldVertical],
    ["ungroup", Ungroup],
    ["unlink", Unlink],
    ["unlink-2", Unlink2],
    ["unlock", Unlock],
    ["unlock-keyhole", UnlockKeyhole],
    ["unplug", Unplug],
    ["upload", Upload],
    ["upload-cloud", UploadCloud],
    ["usb", Usb],
    ["user", User],
    ["user-2", User2],
    ["user-check", UserCheck],
    ["user-check-2", UserCheck2],
    ["user-circle", UserCircle],
    ["user-circle-2", UserCircle2],
    ["user-cog", UserCog],
    ["user-cog-2", UserCog2],
    ["user-minus", UserMinus],
    ["user-minus-2", UserMinus2],
    ["user-plus", UserPlus],
    ["user-plus-2", UserPlus2],
    ["user-round", UserRound],
    ["user-round-check", UserRoundCheck],
    ["user-round-cog", UserRoundCog],
    ["user-round-minus", UserRoundMinus],
    ["user-round-plus", UserRoundPlus],
    ["user-round-search", UserRoundSearch],
    ["user-round-x", UserRoundX],
    ["user-search", UserSearch],
    ["user-square", UserSquare],
    ["user-square-2", UserSquare2],
    ["user-x", UserX],
    ["user-x-2", UserX2],
    ["users", Users],
    ["users-2", Users2],
    ["users-round", UsersRound],
    ["utensils", Utensils],
    ["utensils-crossed", UtensilsCrossed],
    ["utility-pole", UtilityPole],
    ["variable", Variable],
    ["vegan", Vegan],
    ["venetian-mask", VenetianMask],
    ["vibrate", Vibrate],
    ["vibrate-off", VibrateOff],
    ["video", Video],
    ["video-off", VideoOff],
    ["view", View],
    ["voicemail", Voicemail],
    ["volume", Volume],
    ["volume-1", Volume1],
    ["volume-2", Volume2],
    ["volume-x", VolumeX],
    ["vote", Vote],
    ["wallet", Wallet],
    ["wallet-2", Wallet2],
    ["wallet-cards", WalletCards],
    ["wallpaper", Wallpaper],
    ["wand", Wand],
    ["wand-2", Wand2],
    ["warehouse", Warehouse],
    ["watch", Watch],
    ["waves", Waves],
    ["waypoints", Waypoints],
    ["webcam", Webcam],
    ["webhook", Webhook],
    ["weight", Weight],
    ["wheat", Wheat],
    ["wheat-off", WheatOff],
    ["whole-word", WholeWord],
    ["wifi", Wifi],
    ["wifi-off", WifiOff],
    ["wind", Wind],
    ["wine", Wine],
    ["wine-off", WineOff],
    ["workflow", Workflow],
    ["wrap-text", WrapText],
    ["wrench", Wrench],
    ["x", X],
    ["x-circle", XCircle],
    ["x-octagon", XOctagon],
    ["x-square", XSquare],
    ["youtube", Youtube],
    ["zap", Zap],
    ["zap-off", ZapOff],
    ["zoom-in", ZoomIn],
    ["zoom-out", ZoomOut],
  ]);

  export default lucideIcons;
